module.exports = __webpack_public_path__ + "static/media/background.bfcc44f5.png";